export const sortByEnum = {
  FirstName: 'First Name',
  LastNameGroupName: 'Last Name/Group Name',
  // CompanyName: 'Company Name',
  City: 'City',
  State: 'State'
}
